import {NEUTRAL_PLAYER_COLOR} from "../../constants/players";
import {getNeutralPlayerMock} from "./getNeutralPlayerMock";

export const getPlayerByColor = (players, color) => {
  if (color === NEUTRAL_PLAYER_COLOR) {
    return getNeutralPlayerMock();
  }
  return players.find((player) => player.color === color);
}